export default "__VITE_ASSET__1cd87f66__"